module.exports = __webpack_public_path__ + "static/media/Boreal-Besties8.a4436dfb.jpg";